<style scoped>
@import "../../../assets/css/table-list.css";
.form-title {
  line-height: 40px;
  text-indent: 10px;
  background-color: #f3f3f3;
  margin-bottom: 10px;
}
.margin-right10 {
  margin-right: 10px;
}
.detail-group section {
  margin-bottom: 14px;
}
.detail-group section label {
  margin-right: 15px;
}
.detail-group section label,
.detail-group section span {
  display: inline-block;
}
.tx-user {
  width: 50px;
  max-height: 100px;
}
</style>
<style>
.ivu-form-item-content {
  line-height: 33px;
}
</style>
<template>
  <div>
    <h3 class="title">操作记录</h3>
    <div>
      <div class="margin-bottom-10 header-group">
        <label class="margin-right10">用户名</label>
        <Input v-model="d_search_name" placeholder="请输入用户名" />
        <label class="margin-right10">日期</label>
        <DatePicker
          type="daterange"
          :value="d_search_date"
          @on-change="change_date"
          placement="bottom-end"
          placeholder="请选择日期范围"
        ></DatePicker>
        <Button type="primary" @click="search">查询</Button>
      </div>
      <Table :columns="d_columns" border :data="d_data"></Table>
    </div>
    <div class="margin-top-20">
      <Page
        :total="d_total"
        show-sizer
        show-total
        @on-change="flip"
        @on-page-size-change="change_size"
        class="pull-right"
      ></Page>
      <div class="clear-both"></div>
    </div>
  </div>
</template>
<script>
import apiContract from "../../../api/contract.js";
export default {
  name: "noticeMain_page",
  data() {
    return {
      params: {},
      d_total: 0,
      d_page: 1,
      d_page_size: 10,
      d_search_date: [],
      d_search_name: "",
      d_columns: [
        {
          title: "合同编号",
          key: "ContractID",
          width: 160,
        },
        {
          title: "用户",
          key: "UserName",
        },
        {
          title: "修改日期",
          key: "EditDate",
        },
        {
          title: "合同名称",
          key: "ContractName",
        },
        {
          title: "修改参数",
          key: "ValueName",
        },
        {
          title: "原始值",
          key: "BeforeValue",
        },
        {
          title: "修改值",
          key: "AfterValue",
        },
      ],
      d_data: [],
      d_del_data: "",
    };
  },
  methods: {
    flip(page) {
      //翻页条件，每页多少条，多少页
      this.params.PageIndex = page;
      this.params.PageSize = this.d_page_size;
      this.pull_data();
    },
    change_size(size) {
      //改变limit 每页显示多少条
      this.params.PageSize = size;
      this.pull_data();
    },
    search() {
      this.params.PageIndex=1;
      this.pull_data();
    },
    change_date(date) {
      this.d_search_date = date;
    },
    pull_data() {
      let _this = this;
      this.params.CondList = [
        {
          Key: "c.Name",
          Operator: "like",
          Value: this.d_search_name,
        },
        {
          Key: "ch.EditDate",
          Operator: ">=",
          Value: this.d_search_date[0] || "",
        },
        {
          Key: "ch.EditDate",
          Operator: "<=",
          Value: this.d_search_date[1] || "",
        },
      ];
      apiContract.getContractHistoryList.post(this.params).then((_data) => {
        if (_data.data.ExeSuccess && _data.data.LoginSuccess) {
          let requestResult = _data.data.Data;
          let rowsList = requestResult.RowsList;
          _this.d_data = rowsList;
          _this.d_total = requestResult.Total;
        } else {
          this.$Message.error(_data.data.Msg);
        }
      });
    },
  },
  created() {
    this.params = JSON.parse(
      JSON.stringify(apiContract.getContractHistoryList.data)
    );
    this.pull_data();
  },
  mounted() {},
};
</script>
